package app.view

import app.api.StagesApi
import app.components.ModalStore
import app.components.warningModal
import app.model.Stage
import app.svg.arrowDown
import app.svg.close
import app.svg.delete
import app.svg.edit
import dev.fritz2.core.*

data class EditState(
    val stage: Stage,
    val editName: String,
    val editOrdering: String
)

fun RenderContext.stagesView(stagesApi: StagesApi) {
    val showCreateStageMenu = storeOf(false)
    val inputNameValue = storeOf("")
    val inputOrderingValue = storeOf("")
    val showModalStore = storeOf(ModalStore(show = false, message = ""))
    val editingStage = storeOf<EditState?>(null)
    warningModal(modalStore = showModalStore)
    stagesApi.handler(Unit)
    stagesApi.data.render { stages ->
        div("flex flex-col gap-4 mt-4 dark:text-white") {
            if (stages.isEmpty()) {
                div("border rounded-lg p-4 dark:border-gray-700 dark:bg-gray-800") { +"No Stages found" }
            }
            stages.forEach { stage ->
                div("border rounded-lg p-4 flex group dark:border-gray-700 dark:bg-gray-800") {
                    editingStage.data.render { editState ->
                        if (editState?.stage?.id == stage.id) {
                            div("flex flex-col gap-2 w-full") {
                                div("flex gap-2") {
                                    input("border rounded-lg p-2 flex-1 dark:bg-gray-700 " +
                                            "dark:border-gray-600 dark:text-white dark:placeholder-gray-400") {
                                        value(editState.editName)
                                        changes.values() handledBy {
                                            editingStage.update(
                                                editState.copy(editName = it)
                                            )
                                        }
                                    }
                                    input("border rounded-lg p-2 flex-1 dark:bg-gray-700 " +
                                            "dark:border-gray-600 dark:text-white dark:placeholder-gray-400") {
                                        type("number")
                                        value(editState.editOrdering)
                                        changes.values() handledBy {
                                            editingStage.update(
                                                editState.copy(editOrdering = it)
                                            )
                                        }
                                    }
                                }
                                div("flex gap-2 ml-auto") {
                                    button("px-2 py-1 bg-green-500 text-white rounded") {
                                        edit("size-6")
                                        clicks handledBy {
                                            stagesApi.putStage(
                                                Stage(
                                                    id = stage.id,
                                                    name = editState.editName,
                                                    ordering = editState.editOrdering.toInt()
                                                )
                                            )
                                            editingStage.update(null)
                                        }
                                    }
                                    button("px-2 py-1 bg-gray-500 text-white rounded") {
                                        close("size-6")
                                        clicks handledBy {
                                            editingStage.update(null)
                                        }
                                    }
                                }
                            }
                        } else {
                            div("flex items-center w-full") {
                                p("flex-1") { +"${stage.name} (${stage.ordering})" }
                                div("ml-auto invisible group-hover:visible flex gap-2") {
                                    button("dark:text-white") {
                                        edit("size-6")
                                        clicks handledBy {
                                            editingStage.update(
                                                EditState(
                                                    stage = stage,
                                                    editName = stage.name,
                                                    editOrdering = stage.ordering.toString()
                                                )
                                            )
                                        }
                                    }
                                    button("dark:text-white") {
                                        delete("size-6")
                                        clicks handledBy {
                                            showModalStore.update(
                                                ModalStore(
                                                    show = true,
                                                    message = "Are you sure you want to delete ${stage.name}?",
                                                    onConfirm = { stagesApi.deleteStage(stage.id) }
                                                )
                                            )
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        div("flex flex-col mt-4") {
            showCreateStageMenu.data.render { show ->
                div(if (!show) "hidden" else "w-full flex mb-4 gap-4") {
                    input("border w-full rounded-lg p-2 h-14 dark:bg-gray-700 " +
                            "dark:border-gray-600 dark:text-white dark:placeholder-gray-400") {
                        placeholder("Stage Name")
                        value(inputNameValue.data)
                        changes.values() handledBy inputNameValue.update
                    }
                    input("border w-full rounded-lg p-2 h-14 dark:bg-gray-700 " +
                            "dark:border-gray-600 dark:text-white dark:placeholder-gray-400") {
                        placeholder("Ordering Value")
                        type("number")
                        value(inputOrderingValue.data)
                        changes.values() handledBy inputOrderingValue.update
                    }
                    button("px-4 py-2 bg-blue-500 text-white rounded") {
                        +"Submit"
                        clicks handledBy {
                            stagesApi.postStage(
                                Pair(
                                    inputNameValue.current,
                                    inputOrderingValue.current
                                )
                            )
                            inputNameValue.update("")
                            inputOrderingValue.update("")
                            showCreateStageMenu.update(false)
                        }
                    }
                }
                button("m-auto dark:text-white") {
                    clicks handledBy showCreateStageMenu.handle { it.not() }
                    title(if (!show) "Create Stage" else "Close")
                    arrowDown(if (!show) "size-6" else "size-6 rotate-180")
                }
            }
        }
    }
}